import type { QuoteWidget } from './QuoteWidget';
import {
    TimelineSlot,
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { z } from 'zod';
import type { AutoTextResizerPropertyInterface } from '../../Utility/Vue/components/AutoTextResizer';
import { zMarshalToStrictInt } from '../../ReachApi/Marshallers';

export const ZodQuoteWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    css_template: z.string(),
    displaynum: z.number().nullish(),
    gui_css: z.string().nullable(),
    number_of_quotes: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
    quote_type: z.string(),
    template: z.string(),
});

export type QuoteWidgetConfigurationDetails = z.infer<typeof ZodQuoteWidgetConfigurationDetails>;

export const ZodQuoteWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    config: ZodQuoteWidgetConfigurationDetails,
    type: z.literal(WidgetType.QUOTE),
});

export type QuoteWidgetConfiguration = z.infer<typeof ZodQuoteWidgetConfiguration>;

export type QuoteWidgetTimelineSlot = TimelineSlot<QuoteWidgetTimelineSlotObject, QuoteWidget>;

export type QuoteWidgetTimelineSlotObject = {
    quote: QuoteObject;
};

export type QuoteObject = {
    author: string;
    background_link: string;
    id: number;
    quote: string;
    template: number;
    title: string;
    type: string;
};

/**
 * Quote item used in templates table.
 */
export type QuoteTemplateItemData = {
    author?: string;
    background_link: string;
    id: number;
    quote?: string;
    title?: string;
};

/**
 * Quote template used in templates table.
 */
export type QuoteTemplateData = {
    metadata: {
        landscape: boolean;
        fontResize: boolean;
        fontProperties: AutoTextResizerPropertyInterface;
    };
    quoteArray: QuoteTemplateItemData[];
    widget: { id: number };
};

export enum QuoteLayoutType {
    LANDSCAPE = 'landscape',
    PORTRAIT = 'portrait',
}

export enum QuoteType {
    FAMOUS = 'famous',
    INSPIRATIONAL = 'inspirational',
}
